import styles from './LinkListGrid.module.scss';
import { UI_LinkList, LinkListProps } from '../LinkList/LinkList';

export interface LinkListGridProps {
	linkList: LinkListProps[];
}

export const UI_LinkListGrid = ({ linkList }: LinkListGridProps) => {
	return (
		<div className={styles.LinkListGrid}>
			{linkList.map((item, index) => (
				<div className={styles.LinkListGridItem} key={index}>
					<UI_LinkList
						className={styles.LinkListGridItem_list}
						heading={item.heading}
						headingLink={item.headingLink}
						linkListItems={item.linkListItems}
					/>
				</div>
			))}
		</div>
	);
};
